var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-self"},[_c('Menu',{attrs:{"mode":"horizontal","active-name":"/"},on:{"on-select":_vm.selected}},_vm._l((_vm.navData),function(item){return _c('MenuItem',{key:item.key,attrs:{"name":item.link}},[_vm._v(" "+_vm._s(item.name)+"\n    ")])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883fa5ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = null
// module chunks = 